import { useEffect } from 'react';
import './ActionDrawer.css';
import ToolTipText from './ToolTipText';

const ActionDrawer = ({ open, onClose, row, actions = [], drawerDisplayName }) => {
  useEffect(() => {
    if (!open) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className={`drawer-overlay ${open ? "open" : ""}`} onClick={onClose}>
      <div className="drawer" onClick={(e) => e.stopPropagation()}>
        <div className="drawer-header">
          <h3 className="drawer-title">
            Actions
            {drawerDisplayName && <span className="drawer-subtitle"> {drawerDisplayName}</span>}
          </h3>
          <button className="drawer-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="drawer-body">
          {actions.map((item, idx) => (
            <div className="drawer-item" key={idx+item?.label}>
              <ToolTipText hoverText={item?.showTooltip ? item?.showTooltip : ''}>
                 <span className="drawer-label">{item?.label}</span>
              </ToolTipText>
              <div className="drawer-content">{item?.component({ row })}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActionDrawer;
